<template>
    <div class="row">
        
        <div class="col-md-12">
            <div>
                All check-ins assigned <input style="width: fit-content;display: inline;" maxlenght="6" size="6"
                                              id="all_checkin_points" name="all_checkin_points" class="form-control"
                                              type="text" v-model.number="all_checkin_points"/> points
                <span class="invalid-feedback" style="display: block;"
                      v-if="errors.all_checkin_points">@{{ errors.all_checkin_points }}</span>
            </div>
        </div>
        <div class="col-md-12">
            <div>
                 All standard redemptions assigned <input style="width: fit-content;display: inline;" maxlenght="6"
                                                         size="6" id="all_standard_redemptions"
                                                         name="all_standard_redemptions" class="form-control"
                                                         type="text" v-model.number="all_standard_redemptions"/> points
                <span class="invalid-feedback" style="display: block;"
                      v-if="errors.all_standard_redemptions">@{{ errors.all_standard_redemptions }}</span>
            </div>
        </div>
        <div  class="col-md-12">
            Points Redemption End Date
            <select class="endsGroup form-control" v-model="end_type">
                <option value="duration">Days after end</option>
				<option value="end">Upon Pass Expiration</option>
                <option value="date">Specific Date</option>
            </select>
    
            <div class="d-flex mt-3" v-if="end_type === 'duration'">
                <div>
                    Points Usable until <input style="width: fit-content;display: inline;" maxlenght="6"
                                        size="6" id="all_standard_redemptions"
                                        name="all_standard_redemptions" class="form-control"
                                        type="text" v-model.number="usable_until_days"/> days after deal ends
                    <span class="invalid-feedback" style="display: block;"
                          v-if="errors.usable_until_days">@{{ errors.usable_until_days }}</span>
                </div>
            </div>
    
            <div id="endDateDiv" class="mt-3" v-if="end_type === 'date'">
                <div class="form-group">
                    <div class="input-group date">
                        Points are valid until: <date-picker style="width: fit-content;display: inline;" v-model="usable_before_date"></date-picker>
                        <span class="input-group-prepend">
                                                                                    <span class="input-group-text">
                                                                                        <i class="far fa-calendar-alt"></i>
                                                                                    </span>
                                                                                </span>
                    </div>
                </div>
            </div>
        </div>
        
        <br/>
        
        <div  class="col-md-12">
            <div class="col-md-6">
                <multiselect
                    v-model="filterCategories"
                    :options="allCategories"
                    :multiple="true"
                    track-by="id"
                    :allow-empty="true"
                    label="name"
                    placeholder="--filter by venue category--"
                ></multiselect>
            </div>
            <div class="col-md-6">
                <multiselect
                    v-model="filterProductTypes"
                    :options="allProductTypes"
                    :multiple="true"
                    track-by="code"
                    :allow-empty="true"
                    label="name"
                    placeholder="--filter by product type--"
                ></multiselect>
            </div>
    
            <div class="col-md-6">
                <multiselect
                    v-model="filterRedemptionValidation"
                    :options="allRedemptionValidation"
                    :multiple="true"
                    track-by="id"
                    :allow-empty="true"
                    label="name"
                    placeholder="--filter by redemption validation--"
                ></multiselect>
            </div>
            <div class="col col-md-12">
                <div class="row" v-for="product in productsFiltered">
                    <div class="col-md-3">
                        <input class="form-control" @keypress="isNumber($event)" :value="getPoints(product.product_id)"
                               @input="setPoints(deal.id, product.product_id, $event.target.value)"/>
                    </div>
                    <div class="col-md-9">
                        {{
                            (allProductsById[product.product_id]?.venueName || `Venue ${product.venue_id}`) + ' - ' + product.name
                        }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const ALL_REDEMPTION_VALIDATION = [
    {
        id: '',
        name: 'None'
    },
    {
        id: 'pin',
        name: 'Pin'
    },
    {
        id: 'gps',
        name: 'Gps'
    },
    {
        id: 'gpsOrPin',
        name: 'Gps or Pin'
    }
];


export default {
    props: {
        deal: Object,
        deals: Array,
        products: Array,
        rule: Object,
        venues: Array,
    },
    data: () => ({
        dateTimeFormat: { sideBySide: true },
        filterCategories: [],
        filterProductTypes: [],
        filterRedemptionValidation: [],
        last_date: [],
        allRedemptionValidation: ALL_REDEMPTION_VALIDATION,
        errors: {},
       
    }),
    methods: {
        setDefaultModel(dealId) {
            if (!this.rule.settings.dealProducts || Array.isArray(this.rule.settings.dealProducts)) {
                this.$set(this.rule.settings, 'dealProducts', {});
            }
            if (!this.rule.settings.dealProducts[dealId]) {
                this.$set(this.rule.settings.dealProducts, dealId, {});
            }
        },
        setPoints(dealId, productId, points) {
            if (!/^\d+$/.test(points)) {
                points = '';
            }

            this.setDefaultModel(dealId);
			const parsed = parseInt(points);
            this.$set(this.rule.settings.dealProducts, productId, Number.isNaN(parsed) ? undefined : parsed);
        },
        getPoints(productId) {
            return this.rule.settings.dealProducts ? this.rule.settings.dealProducts[productId] : '';
        },
        keyById(items) {

            const result = {};
            items.forEach(item => result[item.id] = item);
            return result;
        },
        productMatches(product) {
            const plainProduct = this.allProductsById[product.product_id];
            return this.productMatchesCategories(plainProduct) && this.productMatchesTypes(plainProduct) && this.productMatchesRedemptionValidation(plainProduct);
        },
        productMatchesCategories(product) {
            return this.filterCategories.length === 0 ||
                this.venuesById[product.venue_id]?.categories?.some(category =>
                    this.filterCategories.some(filterCat => category.id === filterCat.id)
                );
        },
        productMatchesTypes(product) {
            return this.filterProductTypes.length === 0
                || this.filterProductTypes.some(filterType => product.product_type_code === filterType.code);
        },
        productMatchesRedemptionValidation(product) {
            return this.filterRedemptionValidation.length === 0
                || this.filterRedemptionValidation.some(filterRV => product.redemption_validation === filterRV.id);
        },

        isNumber(evt) {
            const keyPressed = evt.key;
            if (keyPressed < '0' || keyPressed > '9') {
                evt.preventDefault()
            }
        },
    },
    computed: {
        plainProducts() {
            return this.products.reduce((acc, group) =>
                acc.concat(group.options.map(product => ({venueName: group.group_name, ...product}))), []);
        },
        allProductsById() {
            return this.keyById(this.plainProducts);
        },
        productsFiltered() {
            return this.deal.products.sort((a, b) => {
                const venueA = this.allProductsById[a.product_id]?.venueName || `Venue ${a.venue_id}`;
                const venueB = this.allProductsById[b.product_id]?.venueName || `Venue ${b.venue_id}`;
                const productA = a.name;
                const productB = b.name;
                if (venueA < venueB) {
                    return -1;
                }
                if (venueA > venueB) {
                    return 1;
                }
                if (productA < productB) {
                    return -1;
                }
                if (productA > productB) {
                    return 1;
                }
                return 0;
            });
        },
        allCategories() {
            const categories = {};
            this.deal.products.forEach(product => {
                this.venuesById[this.allProductsById[product.product_id].venue_id]?.categories?.forEach(category =>
                    categories[category.id] = category
                );
            });
            return Object.values(categories);
        },
        usable_before_date: {
            get() {
                return Bandwango.dateToLocal(this.rule.settings.end_date_time);
            },
            set(v) {
                this.$set(this.rule.settings, 'end_date_time', Bandwango.dateToUtc(v));
            }
        },
        allProductTypes() {
            let types = {};

            this.deal.products.forEach(product => {

                const productTypeCode = this.plainProducts[product.product_id]?.product_type_code;
                if (productTypeCode) {
                    types[productTypeCode] = {
                        'code': productTypeCode,
                        'name': productTypeCode,
                    };
                }
            });
            types = Object.values(types);
            types.push({
                'code': null,
                'name': 'Not Set',
            });
            return types;
        },
        usable_until_days: {
            get() {
                return this.rule.settings.usable_until_days;
            },
            set(newVal) {
                this.$set(this.rule.settings, 'usable_until_days', newVal);
            },
        },
        all_checkin_points: {
            get() {
                return this.rule.settings.default_checkin_points;
            },
            set(newVal) {
                this.$set(this.rule.settings, 'default_checkin_points', newVal);
            },
        },
        all_standard_redemptions: {
            get() {
                return this.rule.settings.default_standard_points;
            },
            set(newVal) {
                this.$set(this.rule.settings, 'default_standard_points', newVal);
            },
        },
        end_type: {
            get() {
                return this.rule.settings.end_type ?? 'end';
            },
            set(newVal) {
                this.$set(this.rule.settings, 'end_type', newVal);
            },
        },
        venuesById() {
            return this.keyById(this.venues);
        },
    }
}
</script>